/*
 * @Author: long
 * @Date: 2019-12-17 20:14:00
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2022-12-13 15:12:18
 */

const notFind = {
  path: '/404',
  name: 'notFind',
  value: '404'
}

const index = {
  path: '/',
  name: 'index',
  value: '首页'
}

const about = {
  path: '/about',
  name: 'about',
  value: '关于我们'
}

const services = {
  path: '/services/',
  name: 'services',
  value: '我们的服务'
}

const serviceslist = {
  path: '/services/list',
  name: 'serviceslist',
  value: '我们的服务-列表页'
}

const servicescontent = {
  path: '/services/content',
  name: 'servicescontent',
  value: '我们的服务-详情页'
}

const news = {
  path: '/news',
  name: 'news',
  value: '新闻及案例分享'
}

const newscontent = {
  path: '/news/content',
  name: 'newscontent',
  value: '新闻及案例分享-详情页'
}

const training = {
  path: '/training',
  name: 'training',
  value: '技术培训'
}

const traininglist = {
  path: '/training/list',
  name: 'traininglist',
  value: '技术培训-列表页'
}

const trainingcontent = {
  path: '/training/content',
  name: 'trainingcontent',
  value: '技术培训-详情页'
}

const Partners = {
  path: '/Partners',
  name: 'Partners',
  value: '合作伙伴'
}

const database = {
  path: '/database',
  name: 'database',
  value: '细胞系STR数据库在线比对'
}

const literature = {
  path: '/literature',
  name: 'literature',
  value: '细胞鉴定相关文献下载区'
}

const literaturecontent = {
  path: '/literature/content',
  name: 'literaturecontent',
  value: '细胞鉴定相关文献下载区-详情页'
}

const order = {
  path: '/customer/order',
  name: 'order',
  value: '客户中心-我的订单'
}

const ordercontent = {
  path: '/customer/ordercontent',
  name: 'order',
  value: '客户中心-我的订单详情'
}

const contrast = {
  path: '/customer/contrast',
  name: 'contrast',
  value: '客户中心-查询对比'
}

const record = {
  path: '/customer/record',
  name: 'record',
  value: '客户中心-查询对比记录'
}

const recordcon = {
  path: '/customer/record/content',
  name: 'recordcon',
  value: '客户中心-查询对比记录详情'
}

const urliterature = {
  path: '/customer/literature',
  name: 'urliterature',
  value: '客户中心-发布文献'
}

const userinfo = {
  path: '/customer/userinfo',
  name: 'userinfo',
  value: '客户中心-账号管理'
}

export default {
  notFind,
  index,
  about,
  services,
  serviceslist,
  servicescontent,
  news,
  newscontent,
  training,
  traininglist,
  trainingcontent,
  Partners,
  database,
  literature,
  literaturecontent,
  order,
  ordercontent,
  contrast,
  urliterature,
  userinfo,
  record,
  recordcon
}



// WEBPACK FOOTER //
// ./src/router/mould.js